import React from 'react';
import cx from 'classnames';
import { Icon } from '../../Icons';
import styles from '../style.module.css';

export const NextPage = () => {
  const classBtn = cx(
    'pointer bn pa0 flex items-center justify-center boulder ml4 hover-bg-alto br10 transition-ease',
    styles.item,
  );
  return (
    <div className={classBtn}>
      <Icon name="SvgIconArrowRight" customId="next-page" width={14} height={14} />
    </div>
  );
};
